<script>
   /**************************************************************/
   /* Relabeled widget                                           */
   /**************************************************************/

   import { Container, ButtonCancel, ButtonUndo } from 'svelte-controls-basic';


   let {
      relabeled,
      dataset,
      resetRelabeled,
      undoRelabeled,
   } = $props();
</script>

{#if dataset && relabeled && relabeled.length > 0 }
   <!-- dataset is loaded - show info and cancel button -->
   <Container>
      <p class="relabeled">
         <span style="color:#a0a0a0;">Relabeled:</span>
         {#each relabeled as v}
         <span class="item">{dataset.objlabels[v]}</span>
         {/each}
      </p>
      {#if relabeled.length > 1}
      <ButtonUndo onclick={undoRelabeled} />
      {/if}
      <ButtonCancel onclick={resetRelabeled} />
   </Container>
{/if}


<style>
   .relabeled {
      line-height: 1.5em;
      text-align: left;
      padding: 0.5em 0;
      flex: 0 0 80%;
   }

   .relabeled > .item {
      color: #DC143C;
      background: #DC143C20;

      display: inline-block;
      white-space: nowrap;
      vertical-align: middle;
      max-width: 10ch;
      overflow: hidden;
      text-overflow: ellipsis;

      padding: 0.1em 0.5em;
      margin: 0.2em 0.1em;
      border-radius: 0.2em;
   }
</style>